<svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8827_4148)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M20.5 40C31.5457 40 40.5 31.0457 40.5 20C40.5 8.9543 31.5457 0 20.5 0C9.4543 0 0.5 8.9543 0.5 20C0.5 31.0457 9.4543 40 20.5 40ZM10.5 18.75C9.80964 18.75 9.25 19.3096 9.25 20C9.25 20.6904 9.80964 21.25 10.5 21.25H30.5C31.1904 21.25 31.75 20.6904 31.75 20C31.75 19.3096 31.1904 18.75 30.5 18.75H10.5Z" fill="#121212"/>
</g>
<defs>
<clipPath id="clip0_8827_4148">
<rect width="40" height="40" fill="white" transform="translate(0.5)"/>
</clipPath>
</defs>
</svg>
